<div class="summary-container">
  <div class="item quarter">
    <h4 class="title">Start Time</h4>
    <src-pretty-date [value]="inputData.start_time"></src-pretty-date>
  </div>
  <div class="item">
    <h4 class="title">End Time</h4>
    <src-pretty-date [value]="inputData.end_time"></src-pretty-date>
  </div>
  <div class="item-wide">
    <div class="series-rows">
      @for (adjustment of inputData.series_to_adjust; track adjustment) {
        <div class="item-wide series-row">
          <div class="item">
            <h4 class="title">Target Series</h4>
            <p>{{seriesDict[adjustment.target_series_id] ? (seriesDict[adjustment.target_series_id].attributes | nameOrDescription) : 'not set'}}</p>
          </div>
          <div class="item">
            <h4 class="title">To Adjust</h4>
            <p>{{seriesDict[adjustment.series_id] ? (seriesDict[adjustment.series_id].attributes | nameOrDescription) : 'not set'}}</p>
          </div>
          <div class="item">
            <h4 class="title">Factor</h4>
            <p>{{adjustment.factor ?? '-'}}</p>
          </div>
          <div class="item">
            <h4 class="title">Target</h4>
            <p>{{adjustment.target_value}}</p>
          </div>
          @if (adjustment.comment) {
            <div class="item-wide">
              <h4 class="title">Comment</h4>
              <p>{{adjustment.comment}}</p>
            </div>
          }
          @switch (adjustment.adjustment_type) {
            @case ('factor') {
              <div class="item">
                <h4 class="title">Offset</h4>
                <p>{{adjustment.offset}}</p>
              </div>
              <div class="item">
                <h4 class="title">Factor</h4>
                <p>{{adjustment.factor}}</p>
              </div>
            }
            @case ('constant') {
              <div class="item">
                <h4 class="title">Value</h4>
                <p>{{adjustment.value}}</p>
              </div>
            }
          }
        </div>
      }
    </div>
  </div>
</div>
